export interface CheckInCall {
    id: number;
    merchantName: string;
    callName: string;
    days: number;
}

export const checkInCallsMocks: CheckInCall[] = [
    {
        id: 1,
        merchantName: 'Merchant 1',
        callName: 'Call 1',
        days: -5,
    },
    {
        id: 20,
        merchantName: 'Merchant 2',
        callName: 'Call 2',
        days: 5,
    },
    {
        id: 224,
        merchantName: 'Merchant 3',
        callName: 'Call 3',
        days: 10,
    },
];
